import { ReactNode } from 'react';

import { ContractMessage } from '../../../../types/ContractMessage';
import { MoneyMessage } from '../../../../types/MoneyMessage';

export enum SupplierSelectionPriceState {
    HIDDEN = 'hidden',
    LOADING = 'loading',
    AVAILABLE = 'available',
    UNAVAILABLE = 'unavailable',
}

export interface SupplierSelectionRowPrice {
    state: SupplierSelectionPriceState;
    label?: string;
    totalPrice?: MoneyMessage;
    popoverContent?: ReactNode;
    isOutdated?: boolean;
    validUntil?: string;
}

export interface SupplierSelectionRowData {
    id: string;
    title: string;
    meta: string[];
    leadingVisual: ReactNode;
    selected: boolean;
    hasMultipleContracts?: boolean;
    disabled?: boolean;
    limitedTooltip?: string;
    contracts?: ContractMessage[];
    defaultContractId?: string;
    contractPricesByContractId?: Record<string, SupplierSelectionRowPrice>;
    selectedContractId?: string;
    onContractSelect?: (contractId: string) => void;
    price?: SupplierSelectionRowPrice;
    onToggle: () => void;
}
